import taskConfigurationEstimates from './taskConfigurationEstimates';

/**
 * Helper to calculate the total time for a set of tasks
 * The tasks object is the configuration state for a grade
 * @param {Object} tasks - the configuration state for a grade
 * @param {String} tasks.name - the name of the task
 * @param {Array} tasks.configuration - the configuration array
 * @param {String} grade - the grade 0 - 6 to calculate the total time for
 * @returns 
 */
export default function calculateTotalTime(tasks, grade) {
  return tasks.reduce((total, task) => {
    const taskTime = taskConfigurationEstimates[grade][task.name] || 0;
    // the task config can be a boolean or an object with a value and ui property
    if (task.configuration[grade] === true || task.configuration[grade]?.value === true) {
      return total + taskTime;
    }
    return total;
  }, 0);
};